















import breadcrumb from '@/components/breadcrumb.vue';
import navbar from '@/components/navigation-bar.vue';
import sidebar from '@/components/navigation-sidebar.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        navbar,
        sidebar,
        breadcrumb,
    },
})
export default class ApplicationLayout extends Vue {
    private showSidebar: boolean = true;

    private onToggleSidebar(): void {
        this.showSidebar = !this.showSidebar;
    }
}
